import React from "react";
import MyModal from "../Common/MyModal";
import { Button, Modal } from "react-bootstrap";

export default function DescriptionModal() {
  return (
    <MyModal
      title="Description"
      heading="More details"
      size="xl"
      label={<span className="ms-2 text-navy cursor-pointer">Learn more</span>}
      trigger={
        <span className="ms-2 text-navy cursor-pointer">Learn more</span>
      }
    >
      <Modal.Body>
        <p>
          This is a library of pre-built solutions that you can purchase and
          deploy in your workspace. You can filter the solutions by category,
          status, and other criteria to find the ones that best fit your needs.
          Once you purchase a solution, it will be added to your workspace and
          you can start using it right away.{" "}
        </p>

        <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 mb-5">
          <div className="d-flex my-2">
            <div className="fw-bold">Sales description:</div>
            <div>(on payment page)</div>
          </div>
          <div className="d-flex my-2">
            <div className="fw-bold">Category:</div>{" "}
            <div>Internet of Things (IoT)</div>
          </div>
          <div className="d-flex my-2">
            <div className="fw-bold">Solution:</div> <div> M2M Alerting </div>
          </div>
          <div className="d-flex my-2">
            <div className="fw-bold">Business use-case:</div>{" "}
            <div>Network and equipment monitoring</div>
          </div>
          <div className="d-flex my-2">
            <div className="fw-bold">Logic component used :</div>{" "}
            <div>
              monitoring - workflows - communications - reporting - events -
              assets
            </div>
          </div>
          <div className="d-flex my-2">
            <div className="fw-bold">Published:</div> <div>12/02/2026</div>
          </div>
        </div>

        <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 mb-5 text-center">
          <img src="/assets/workflows/solution.png" alt="" className="w-75" />
        </div>

        <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 mb-5">
          <div className="fw-bold "> Description</div>
          <div>
            This solution will give you the ability to set the criteria you need
            to monitor your own or 3rd party, hardware, software, networks or
            web services giving you the tools to automatically manage the event
            and any necessary escalations required to see it to its conclusion.
            You point the monitor you set the parameters you input the expected
            alerts and you associate each to the workflow designed to deal with
            it accordingly. We have done the hard work building the complex
            workflows that manages the process, all you need to do is fill in
            the blanks.
          </div>
          <ul className="mt-3">
            <li className="fw-bold">
              How often and to what detail do you want to monitor your devices
            </li>
            <li className="fw-bold">
              How long and what checks are required before we start the workflow
            </li>
            <li className="fw-bold ">
              Do you want a ticket raised and engineering called out and issued
              the job
            </li>
            <li className="fw-bold ">
              Do you want to engage augmented AI to problem solve
            </li>
            <li className="fw-bold ">
              Who do you want contacted and over what comms how often and over
              what time-line.
            </li>
            <li className="fw-bold ">
              How do you want to handle completion and recovery
            </li>
            <li className="fw-bold ">
              What type of reports do you want and who do you want it sent to
            </li>
          </ul>
        </div>

        <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 mb-5 d-flex gap-4 justify-content-evenly align-items-center">
          <Button className="bg-colored fw-bold border-0">
            I want a Trial
          </Button>
          <Button className="bg-colored fw-bold border-0">
            I want to Buy,
          </Button>
          <Button className="bg-colored fw-bold border-0">
            I need more information
          </Button>
          <Button className="bg-colored fw-bold border-0">
            I want to speak to sales
          </Button>
        </div>
      </Modal.Body>
    </MyModal>
  );
}
